export function formatIqd(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  return new Intl.NumberFormat("en-IQ", {
    style: "decimal",
    maximumFractionDigits: 0,
  }).format(Number.isFinite(n) ? n : 0) + " IQD";
}

export function formatNumber(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  return new Intl.NumberFormat("en").format(Number.isFinite(n) ? n : 0);
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString();
}

export function statusPillClass(status: string): string {
  const s = status.toLowerCase();
  if (s === "active" || s === "paid" || s === "online") return "pill pill-success";
  if (s === "pending" || s === "trial") return "pill pill-warning";
  if (s === "suspended" || s === "failed" || s === "cancelled" || s === "canceled") {
    return "pill pill-danger";
  }
  return "pill";
}
